import { render, staticRenderFns } from "./SfxForm.vue?vue&type=template&id=31ff96c6&scoped=true"
import script from "./SfxForm.vue?vue&type=script&lang=js"
export * from "./SfxForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ff96c6",
  null
  
)

export default component.exports